import {
    autocompleteDimensionsRequest,
    autocompleteTopicsRequest
} from "../../../actions/autocomplete-actions"
import {
    stakeholderUpdateFilterCriteria,
    stakeholderUpdateFilterType
} from "../../../actions/stakeholder-actions"
import StakeholderFilterForm from "./StakeholderFilterForm"
import buildItemConnector from "../../common/build-item-connector"

const mapStateToProps = ({ activeFilterType }) => ({
    activeFilterType: activeFilterType
})

const mapDispatchToProps = dispatch => ({
    onFilterTypeChange: ({ target: { value } }) =>
        dispatch(stakeholderUpdateFilterType(value))
})

export default buildItemConnector(
    "stakeholders",
    true,
    stakeholderUpdateFilterCriteria,
    null,
    {
        onTopicsSearch: autocompleteTopicsRequest,
        onDimensionsSearch: autocompleteDimensionsRequest
    },
    mapStateToProps,
    mapDispatchToProps
)(StakeholderFilterForm)
